import React from 'react';
import PropTypes from 'prop-types';

// `.btn-icon` — a round icon-only button. The CSS sizes it at 40px; the smaller
// sizes the pages ask for are modifier classes (.btn-icon-30 … .btn-icon-34)
// declared next to it in primitives.css, so no dimension lands inline.
export default function IconButton({ size = 40, className, children, ...rest }) {
  const classes = ['btn-icon', size !== 40 && `btn-icon-${size}`, className];
  return (
    <button className={classes.filter(Boolean).join(' ')} {...rest}>
      {children}
    </button>
  );
}

IconButton.propTypes = {
  // Only the sizes that have a matching modifier class in primitives.css.
  size: PropTypes.oneOf([30, 32, 34, 40]),
  className: PropTypes.string,
  children: PropTypes.node,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
};
